import { Box, Button, Stack, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import { MaterialsTable } from './components/MaterialsTable'
import { useGetMaterials } from 'hooks/database/useGetMaterials'

import { styled } from '@mui/material/styles'
import { useCurrentUser } from 'hooks'
import { Header } from 'components'
import { defaultRoutes } from 'pages'
import { useCSVDownloader } from 'react-papaparse'
import { MaterialUploader } from './components/MaterialUploader'

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
})

function getExampleCSV() {
  return [
    {
      'Material Number': '',
      'Part Number': '',
      'Material Description': '',
      'Open Area': '',
      'Gross Weight': '',
      'Safety Depth': ''
    }
  ]
}

/*
 * Page for adding/updating Materials
 */
const MaterialsPage = () => {
  const { materials, query } = useGetMaterials()
  const [csvFile, setCsvFile] = useState(undefined)
  const { CSVDownloader } = useCSVDownloader()
  const [rows, setRows] = useState([])

  useEffect(() => {
    setRows(materials)
  }, [materials])

  const { currentUser } = useCurrentUser()

  const routes = useMemo(() => {
    return defaultRoutes({
      isAdmin: currentUser.isAdmin,
      canAccessRoles: currentUser.canAccessRoles,
      canAccessUsers: currentUser.canAccessUsers
    })
  }, [currentUser.isAdmin, currentUser.canAccessRoles, currentUser.canAccessUsers])

  return (
    <Box sx={{ width: '100%', height: '100%', px: '15px', overlow: 'auto' }}>
      <Header routes={routes} />
      <Stack sx={{ pt: 2, mb: 2 }} direction="row" alignItems="center">
        <Typography variant="h1">Manage materials</Typography>
        <Tooltip
          sx={{
            backgroundColor: 'black !important'
          }}
          followCursor
          title={
            <>
              <Typography variant="subtitle1">
                {`To upload a CSV file, please follow these guidelines. You can download an example CSV by clicking on
                  the "Dowload example" button`}
              </Typography>

              <Stack mt={1}>
                <Typography variant="subtitle2">1. The first row of the CSV should be the header</Typography>
                <Typography mt={0.4} variant="subtitle2">
                  2. The headers should be the following(case sensitive):
                </Typography>
                <Stack ml={2}>
                  <Typography color="secondary" variant="subtitle2">
                    1. Material Number
                  </Typography>
                  <Typography color="secondary" variant="subtitle2">
                    2. Part Number
                  </Typography>
                  <Typography color="secondary" variant="subtitle2">
                    2. Material Description
                  </Typography>
                  <Typography color="secondary" variant="subtitle2">
                    3. Open Area
                  </Typography>
                  <Typography color="secondary" variant="subtitle2">
                    4. Gross Weight
                  </Typography>
                  <Typography color="secondary" variant="subtitle2">
                    5. Safety Depth
                  </Typography>
                </Stack>
              </Stack>
            </>
          }>
          <Button
            sx={{
              ml: '1em'
            }}
            component="label"
            variant="contained"
            size="small"
            color="secondary"
            tabIndex={-1}>
            Add materials
            <VisuallyHiddenInput
              accept=".csv"
              type="file"
              onChange={(event) => {
                setCsvFile(event.target.files[0])

                event.target.value = ''
              }}
            />
          </Button>
        </Tooltip>

        <CSVDownloader bom filename={'DeckMapp-material-import'} data={getExampleCSV}>
          <Button
            sx={{
              ml: '1em'
            }}
            size="small"
            color="primary"
            variant="outlined">
            Download Example CSV
          </Button>
        </CSVDownloader>
      </Stack>

      <MaterialsTable rows={rows} setRows={setRows} isLoading={query.isFetching} />

      {csvFile && (
        <MaterialUploader csvFile={csvFile} onCancel={() => setCsvFile(undefined)} materials={rows} query={query} />
      )}
    </Box>
  )
}
export default MaterialsPage
